export default {
  SUPPORT_ACCESS_OPEN_LINK_CLICK: 'support-access-modal:open',
  SUPPORT_ACCESS_LOADED: 'support-access:loaded',
  KEYBOARD_SHORTCUTS_SHOW: 'keyboard-shorcuts-modal:open',
  CHAT_SHOW: 'chat:open',
  FEEDBACK_SHOW: 'feedback:open',
  INIT_ANNOUNCEKIT: 'init-announcekit',
  CLICK_WHATS_NEW: 'click-whats-new',
  ZENDESK_MESSAGE_UPDATE: 'zendesk-message-update',
  HIDE_BUBBLE: 'support-bubble:hide',
  SHOW_BUBBLE: 'support-bubble:show',
  WALKME_SKIP: 'walk-me:skip',
};
